import { GitLabApi } from 'osep-generator-service-client-v1';
import { useApiConfig } from './useApiConfig';

export const useGitLabDisconnect = () => {
  const { getApiConfig, axiosInstance } = useApiConfig();
  const disconnectFromGitLab = async () => {
    const apiConfig = await getApiConfig();
    const gitLabApi = new GitLabApi(apiConfig, undefined, axiosInstance);
    gitLabApi.removeGitlabAccess();
  };
  return { disconnectFromGitLab };
};
